export const TASK_LIST_MODAL_PAGE_SIZE = 20;
export const TASK_LIST_PAGE_SIZE = 10;
export const TASK_DETAIL_POLL_INTERVAL_MS = 30_000;
